import { useNavigation } from "@react-navigation/native";
import React from "react";
import { Text, TouchableOpacity, View } from "react-native";

import styles from "./styles";

const Button = ({ route, text, titlePage, props, disabled = false }) => {
  const navigation = useNavigation();
  return (
    <View style={styles.contentBtn}>
      <TouchableOpacity
        disabled={disabled}
        onPress={() =>
          navigation.navigate({
            name: route,
            params: { titlePage: titlePage, qtd: props },
          })
        }
        style={styles.btn}
      >
        <Text style={styles.textBtn}>{text}</Text>
      </TouchableOpacity>
    </View>
  );
};

export default Button;
